import { PrismLogoColored, PrismLogoWhite } from 'assets';

export const ColoredPrismLogo = () => (
  <div>
    <img alt="Logo" src={PrismLogoColored} width={140} />
  </div>
);

export const WhitePrismLogo = () => <img alt="Logo" src={PrismLogoWhite} width={100} />;
